module.exports = __webpack_public_path__ + "img/pic_05@2x.37f2fbd8.png";